import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { firstValueFrom } from 'rxjs';

interface SegmentEvent {
  context?: Record<string, unknown> | null;
  properties: unknown[];
}

export interface SegmentTrackingEvent extends SegmentEvent {
  event: string;
}

export interface SegmentPageEvent extends SegmentEvent {
  type: string;
  title: string;
  url: string;
}

export interface SegmentGroupEvent extends SegmentEvent {}

@Injectable({ providedIn: 'root' })
export class SegmentService {
  constructor(private readonly httpClient: HttpClient) {}

  private readonly url = environment.url.segment_api;

  identify(data: { email: string; name: string }) {
    return this.httpClient.post(`${this.url}/identify`, data);
  }

  async page(event: SegmentPageEvent) {
    return await this.post(`${this.url}/page`, event);
  }

  async track(event: SegmentTrackingEvent) {
    return await this.post(`${this.url}/track`, event);
  }

  async createGroup(data: unknown) {
    return await this.post(`${this.url}/group`, data);
  }

  private async post(url: string, data: unknown) {
    return await firstValueFrom(this.httpClient.post(url, data));
  }
}
